import { render } from "./HelloWorld.vue?vue&type=template&id=6cac83af&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=ts"
export * from "./HelloWorld.vue?vue&type=script&lang=ts"

import "./HelloWorld.vue?vue&type=style&index=0&id=6cac83af&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6cac83af"

export default script